import React, { useState } from "react";
import { Link } from "react-router-dom";

const MobileLink = ({ title, links, setIsMobileMenuOpen }) => {
  const [isLinkOpen, setIsLinkOpen] = useState(false);

  const openLinks = () => {
    setIsLinkOpen((prevState) => !prevState);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
    setIsLinkOpen(false);
  };
  return (
    <div className="navbar-mobile_links-container">
      <div className="navbar-mobile_btn">
        <button className="navbar-mobile_btn-links" onClick={openLinks}>
          <h1 className="title">{title}</h1>
        </button>
      </div>
      <div className={isLinkOpen ? "navbar-mobile_links" : "hidden"}>
        {links.map((item, index) => {
          const { label, icon, url } = item;
          return (
            <Link
              key={index}
              to={url}
              onClick={closeMobileMenu}
              className="mobile-nav-links"
            >
              {icon} {label}
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default MobileLink;
